import type { ComponentType, SVGProps } from "react"
import {
  FaArrowRight,
  FaCalendarDays,
  FaEnvelope,
  FaGlobe,
  FaLocationDot,
  FaPhone,
  FaSquareArrowUpRight,
  FaBagShopping,
  FaWhatsapp,
} from "react-icons/fa6"

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>

const iconMap: Record<string, { label: string; icon: IconComponent }> = {
  phone: { label: "טלפון", icon: FaPhone },
  whatsapp: { label: "וואטסאפ", icon: FaWhatsapp },
  email: { label: "אימייל", icon: FaEnvelope },
  website: { label: "אתר", icon: FaGlobe },
  location: { label: "מפות", icon: FaLocationDot },
  link: { label: "קישור", icon: FaArrowRight },
  shop: { label: "חנות", icon: FaBagShopping },
  calendar: { label: "פגישה", icon: FaCalendarDays },
  external: { label: "חיצוני", icon: FaSquareArrowUpRight },
}

export type ButtonIconName = keyof typeof iconMap

export const buttonIconOptions = [
  { value: "", label: "ללא אייקון" },
  ...Object.entries(iconMap).map(([value, entry]) => ({
    value,
    label: entry.label,
  })),
]

export function getButtonIcon(name?: string | null) {
  if (!name) return null
  return iconMap[name]?.icon ?? null
}

export function buttonIconLabel(name?: string | null) {
  if (!name) return "ללא אייקון"
  return iconMap[name]?.label ?? "אייקון"
}
